import React, {useContext, useEffect, useState} from 'react';
import {auth, db} from "../utils/firebaseApp";
import {collection, doc, getDoc, getDocs, query, where} from "firebase/firestore";
import {Card, CardContent, CircularProgress, IconButton} from "@mui/material";
import {AppContext} from "../utils/AppContext";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {IconMinus, IconPlus} from "@tabler/icons-react";
import Grid from "@mui/material/Grid";
import {Header} from "../shared-components/Header";
import Button from "@mui/material/Button";
import {sumEverythingInCart} from "../utils/sharedFunctions";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import noStand from '../assets/no stand.png'
import backgroundImage from '../assets/charge.svg'

const StandPage = () => {
    const [stands, setStands] = useState([])
    const [selectedStand, setSelectedStand] = useState(null)
    const {state: {currentUser, cart}, dispatch} = useContext(AppContext);
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getBarData = async () => {
            try {
                setLoading(true)
                const docRef = doc(db, "stands", currentUser.stand);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setSelectedStand(docSnap.data())
                }
                setLoading(false)
            } catch (e) {
                console.log(e)
            }
        }
        if (currentUser.stand) getBarData()
    }, [])

    if (loading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
                <CircularProgress/>
            </Box>
        );
    }

    if ((!currentUser.stand || !selectedStand || !selectedStand.items || selectedStand.items.length === 0) && !loading) {
        return (
            <Box sx={{justifyContent: 'center', textAlign: 'center'}}>
                <Header/>
                <img src={noStand} alt={'stand'} style={{width: '100%', maxWidth: 300}}/>
                <Typography variant={'h2'}>No stands assigned, or no items to display contact admin for
                    support!</Typography>
            </Box>
        )
    }


    console.log(selectedStand)

    function changeQuantity(action, itemToAdd) {
        console.log('cart')
        console.log(cart)
        const itemExists = cart.filter(item => item.name === itemToAdd.name).length > 0

        if (!itemExists && action === 'increase') {
            itemToAdd.quantity = 0
            cart.push(itemToAdd)
        }

        cart.forEach(item => {
            if (item.name === itemToAdd.name) {
                switch (action) {
                    case 'increase':
                        item.quantity += 1
                        break
                    case 'decrease':
                        if (item.quantity > 0) {
                            item.quantity -= 1
                        }
                        break
                }
            }
        })

        dispatch({cart: [...cart]})
    }


    return (
        <div>
            <Header standName={selectedStand.name}/>
            <Box sx={{
                backgroundColor: '#f4f4f4',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                minHeight: '100dvh',
            }}>
                <Grid container direction={'column'} spacing={2} sx={{padding: 2}} alignItems={'center'}>
                    <Grid item sx={{marginBottom: 5, maxWidth: '800px', width: '100%'}}>
                        <Button
                            onClick={() => navigate('/charge')}
                            color={'primary'}
                            sx={{color: 'white'}}
                            variant={'contained'} size={'large'}
                            disabled={cart && sumEverythingInCart(cart) === 0}
                            fullWidth><strong>🪙{cart && sumEverythingInCart(cart)}</strong></Button>
                    </Grid>
                    {
                        selectedStand?.items.map(item => {
                            return (
                                <Grid item sx={{maxWidth: '800px', width: '100%'}}>
                                    <Card sx={{minWidth: 275, borderRadius: 5}}>
                                        <CardContent>
                                            <Stack direction={'row'}>
                                                <Stack direction={'row'} spacing={2} sx={{mr: 2}}>
                                                    <IconButton onClick={() => changeQuantity('increase', item)}>
                                                        <IconPlus/>
                                                    </IconButton>
                                                    <IconButton onClick={() => changeQuantity('decrease', item)}>
                                                        <IconMinus/>
                                                    </IconButton>
                                                </Stack>
                                                <Typography variant={'h4'}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                flexGrow: 1,
                                                                maxWidth: 150,
                                                            }}>{item.name}</Typography>
                                                <Typography variant={'h3'}
                                                            color={'primary'}
                                                            sx={{display: 'flex', alignItems: 'center'}}>
                                                    <strong>{cart?.filter(itemObject => itemObject.name === item.name)[0]?.quantity}
                                                    </strong>
                                                </Typography>

                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Box>
        </div>
    );
};

export default StandPage;
